import { extendObservable } from 'mobx';
import Get from './Get.js';
import Grow from './Grow.js';
import Keep from './Keep.js';

export default class Root {
  constructor() {
    extendObservable(this, {
      pressed: false,
    });

    this.getStore = new Get(this);
    this.growStore = new Grow(this);
    this.keepStore = new Keep(this);
  }
}
